<template lang="pug">
  a.socialButton(v-show="to" :class="{ 'socialButton--fill': fill }" :href="to" target="_blank")
    font-awesome-icon(:icon="['fab', icon]" size="lg")
</template>

<script>
export default {
  name: 'socialButton',
  props: {
    to: {
      type: String,
      default: '',
    },
    network: {
      type: String,
      required: true,
    },
    fill: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon () {
      switch (this.network) {
        case 'instagram':
          return 'instagram'
        case 'twitter':
          return 'x-twitter'
        case 'linkedin':
          return 'linkedin-in'
        case 'facebook':
        default:
          return 'facebook-f'
      }
    },
  },
}
</script>

<style scoped lang="scss">
.socialButton {
  position: relative;
  display: inline-block;
  height: 36px;
  width: 36px;
  border-radius: 1000px;
  border: 2px solid $siteLight;
  margin-right: 8px;
  transition: all $transitionSlow ease;

  > svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:last-of-type {
    margin-right: 0;
  }

  &--fill {
    background-color: $siteLight;
    color: $white;

    &:hover,
    &:focus {
      background-color: $brandPrimary;
    }
  }

  &:focus {
    outline: none;
  }

  &:hover,
  &:focus {
    border-color: $brandPrimary;
  }
}
</style>
